<template>
    <div>
        <draggable
            ref="headers"
            v-model="headerList"
            class="lists"
            @end="updateHeaderOrder(tabIndex)"
        >
            <div
                v-for="(head, hIndex) in headerList"
                :key="hIndex"
                class="header-list"
            >
                <ds-card>
                    <ds-card-header>
                        <div class="tabs-card">
                            <ds-icon class="drag-icon drag-target" name="draggable" />
                            <div class="fields-icons">
                                <ds-editable-text
                                    v-model="head.name"
                                    always-show-icon
                                    @input="addHeaderNames(hIndex, head.name)"
                                >
                                    <span class="editable-text-name">
                                        {{ head.name }}
                                    </span>
                                </ds-editable-text>

                                <span class="field-names-text">(header, {{ head.components.length }}
                                    fields)
                                </span>
                            </div>

                            <div class="moreOptions">
                                <div class="fields-icons-remove">
                                    <ds-tooltip position="left">
                                        <template #reference>
                                            <div class="fields-icons">
                                                <ds-icon-button
                                                    @click="openHeaderDeleteConfirmModal(head.id)"
                                                >
                                                    <ds-icon
                                                        class="fields-more-remove-icons"
                                                        name="minus-circle"
                                                    />
                                                </ds-icon-button>
                                            </div>
                                        </template>

                                        <template #default>
                                            <div>
                                                Remove header with {{ head.components.length }} fields
                                            </div>
                                        </template>
                                    </ds-tooltip>
                                </div>

                                <span class="chevron-header" @click="toggleHeaderMoreOptions(head.name)">
                                    <ds-icon :name="(head.name !== moreOptionHeaderName ? moreMap.get(head.name) : moreOptions) ? 'chevron-up' : 'chevron-down'" />
                                </span>
                            </div>
                        </div>
                    </ds-card-header>

                    <ds-card-body>
                        <draggable
                            v-if="head.name !== moreOptionHeaderName ? moreMap.get(head.name) : moreOptions"
                            ref="fieldNames"
                            v-model="head.components"
                            class="lists"
                            @end="updateFieldOrder(tabIndex, hIndex)"
                        >
                            <div
                                v-for="(fieldNames, fIndex) in head.components"
                                :key="fIndex"
                                class="names-incard"
                            >
                                <div>
                                    <ds-icon class="drag-icon drag-target-field" name="draggable" />

                                    <span>
                                        {{ fieldNames.name }}
                                    </span>

                                    <ds-icon-button
                                        v-if="fieldNames.contentType && fieldNames.contentType.includes('CUSTOM')"
                                        class="icon-only"
                                        @click="editCustomField(fieldNames, tabIndex, hIndex, fIndex)"
                                    >
                                        <ds-icon class="drag-icon drag-target-field" name="edit" />
                                    </ds-icon-button>

                                    <span class="field-names-text">{{ isCustomOrSystemField(fieldNames) }}
                                    </span>

                                    <div class="fields-icons-remove">
                                        <ds-tooltip v-if="!isRemoveDeleteFieldOptionEnabled" position="left">
                                            <template #reference>
                                                <ds-icon-button
                                                    v-if="fieldNames.contentType.includes('CUSTOM')"
                                                    class="icon-only"
                                                    @click="openToggleFieldDeleteConfirmModal(fieldNames)"
                                                >
                                                    <ds-icon
                                                        class="fields-more-remove-icons"
                                                        name="trash-2"
                                                    />
                                                </ds-icon-button>
                                            </template>

                                            <template #default>
                                                <div>Delete field</div>
                                            </template>
                                        </ds-tooltip>

                                        <ds-tooltip position="left">
                                            <template #reference>
                                                <ds-icon-button
                                                    class="icon-only"
                                                    @click="openToggleFieldRemoveConfirmModal(fieldNames.id)"
                                                >
                                                    <ds-icon
                                                        class="fields-more-remove-icons"
                                                        name="minus-circle"
                                                    />
                                                </ds-icon-button>
                                            </template>

                                            <template #default>
                                                <div>Remove field</div>
                                            </template>
                                        </ds-tooltip>
                                    </div>
                                </div>
                            </div>
                        </draggable>

                        <ds-dropdown
                            v-if="head.name !== moreOptionHeaderName ? moreMap.get(head.name) : moreOptions"
                            class="dropdown add-a-field-dropdown"
                        >
                            <span v-if="isManageLayoutGroupingUpSystemFieldsEnabled" class="add-field" @click="addAddressField(tabIndex, hIndex)">
                                <ds-icon name="add" />

                                <span>Add a field</span>
                            </span>
                            <span v-else class="add-field">
                                <ds-icon name="add" />

                                <span>Add a field</span>
                            </span>

                            <div slot="menu">
                                <div>
                                    <div class="search">
                                        <ds-input-field
                                            v-model="searchCriteria"
                                            class="search-input"
                                            data-qa="company-search"
                                            placeholder="Search"
                                            type="input"
                                            @click.native.stop
                                        >
                                            <ds-icon slot="leading" name="search" />

                                            <span
                                                v-show="searchCriteria"
                                                slot="trailing"
                                                class="clear-icon"
                                                @click="clearSearch"
                                            >
                                                <ds-icon name="x" />
                                            </span>
                                        </ds-input-field>
                                    </div>

                                    <div class="search-border" />

                                    <div
                                        class="dropdown-menu-item add-field new-custom-field-label"
                                        @click="addACustomFieldModal(tabIndex, hIndex)"
                                    >
                                        <ds-icon class="add-icon" name="add" />

                                        <div class="add-tab-label">
                                            New custom field
                                        </div>
                                    </div>

                                    <div>
                                        <div
                                            v-if="searchCustomFieldsResults.length > 0"
                                            class="from-template"
                                        >
                                            Custom fields
                                        </div>

                                        <ds-list-item
                                            v-for="(cField, custIndex) in searchCustomFieldsResults"
                                            :key="cField.id"
                                            :title="cField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedCustomField(cField, custIndex, tabIndex, hIndex)"
                                        />

                                        <div v-if="isManageLayoutGroupingUpSystemFieldsEnabled">
                                            <div
                                                v-if="searchGeneralInformationResults.length>0"
                                                class="from-template"
                                            >
                                                {{ allGroupedFields.generalInformationText }}
                                            </div>

                                            <ds-list-item
                                                v-for="(infoField, infoIndex) in searchGeneralInformationResults"
                                                :key="`infoIndex${infoField.id}`"
                                                :title="infoField.name"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showAddedGeneralInfoField(infoField, infoIndex, tabIndex, hIndex)"
                                            />

                                            <div
                                                v-if="searchEmailAndSocialMediaResults.length > 0"
                                                class="from-template"
                                            >
                                                {{ allGroupedFields.emailAndSocialMediaText }}
                                            </div>

                                            <ds-list-item
                                                v-for="(socialField, socialIndex) in searchEmailAndSocialMediaResults"
                                                :key="`socialIndex${socialField.id}`"
                                                :title="socialField.name"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showAddedEmailAndSocialMediaField(socialField, socialIndex, tabIndex, hIndex)"
                                            />

                                            <div
                                                v-if="searchPhoneAndFaxResults.length > 0"
                                                class="from-template"
                                            >
                                                {{ allGroupedFields.phoneAndFaxText }}
                                            </div>

                                            <ds-list-item
                                                v-for="(faxField, faxIndex) in searchPhoneAndFaxResults"
                                                :key="`faxIndex${faxField.id}`"
                                                :title="faxField.name"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showAddedPhoneAndFaxField(faxField, faxIndex, tabIndex, hIndex)"
                                            />

                                            <div
                                                v-if="searchAddressFieldsResults.length > 0"
                                                class="from-template"
                                            >
                                                {{ allGroupedFields.addressFieldsText }}
                                            </div>

                                            <ds-list-item
                                                v-for="(addressField, addressIndex) in searchAddressFieldsResults"
                                                :key="`addressIndex${addressIndex}`"
                                                :title="addressField"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showGroupedAddressFields(addressField, tabIndex, hIndex)"
                                            />

                                            <div
                                                v-if="searchOtherFieldsResults.length > 0"
                                                class="from-template"
                                            >
                                                {{ allGroupedFields.otherFieldsText }}
                                            </div>

                                            <ds-list-item
                                                v-for="(othersField, othersFieldIndex) in searchOtherFieldsResults"
                                                :key="`othersFieldIndex${othersField.id}`"
                                                :title="othersField.name"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showAddedOtherFields(othersField, othersFieldIndex, tabIndex, hIndex)"
                                            />
                                        </div>
                                        <div v-else>
                                            <div
                                                v-if="searchSystemFieldsResults.length>0"
                                                class="from-template"
                                            >
                                                System fields
                                            </div>

                                            <ds-list-item
                                                v-for="(sField, sysIndex) in searchSystemFieldsResults"
                                                :key="sField.id"
                                                :title="sField.name"
                                                border-style="none"
                                                class="list-item-option"
                                                clickable
                                                @click="showAddedSystemField(sField, sysIndex, tabIndex, hIndex)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ds-dropdown>
                    </ds-card-body>
                </ds-card>
            </div>
        </draggable>

        <div>
            <ds-card
                v-if="isAddHeaderEnable"
            >
                <ds-card-header>
                    <div class="tabs-card">
                        <ds-icon class="drag-icon drag-target" name="draggable" />
                        <ds-editable-text
                            v-model="headerName"
                            always-show-icon
                            placeholder="untitled Header"
                            @input="addHeaderNames( null, null)"
                        >
                            <span>
                                {{ headerName }}
                            </span>
                        </ds-editable-text>

                        <div v-if="isRemoveHeaderSectionIfTitleIsEmptyEnabled" class="moreOptions">
                            <ds-tooltip position="left">
                                <template #reference>
                                    <ds-icon-button
                                        class="icon-only"
                                        @click="removeHeaderSectionIfTitleIsEmpty()"
                                    >
                                        <ds-icon
                                            class="fields-more-remove-icons"
                                            name="minus-circle"
                                        />
                                    </ds-icon-button>
                                </template>

                                <template #default>
                                    <div>Remove field</div>
                                </template>
                            </ds-tooltip>
                        </div>
                        <div v-else class="moreOptions">
                            <ds-icon class="add-icon" name="more-horizontal" />
                        </div>
                    </div>
                </ds-card-header>

                <ds-card-body>
                    <ds-dropdown
                        class="dropdown add-a-field-dropdown"
                    >
                        <span v-if="isManageLayoutGroupingUpSystemFieldsEnabled" class="add-field" @click="addAddressField(tabIndex, hIndex)">
                            <ds-icon name="add" />

                            <span>Add a field</span>
                        </span>
                        <span v-else class="add-field">
                            <ds-icon name="add" />

                            <span>Add a field</span>
                        </span>
                        <div v-if="isManageLayoutCantAddFieldEnabled" slot="menu">
                            <div>
                                <div class="search">
                                    <ds-input-field
                                        v-model="searchCriteria"
                                        class="search-input"
                                        data-qa="company-search"
                                        placeholder="Search"
                                        type="input"
                                        @click.native.stop
                                    >
                                        <ds-icon slot="leading" name="search" />

                                        <span
                                            v-show="searchCriteria"
                                            slot="trailing"
                                            class="clear-icon"
                                            @click="clearSearch"
                                        >
                                            <ds-icon name="x" />
                                        </span>
                                    </ds-input-field>
                                </div>

                                <div class="search-border" />

                                <div
                                    class="dropdown-menu-item add-field new-custom-field-label"
                                    @click="addACustomFieldModal(tabIndex, hIndex)"
                                >
                                    <ds-icon class="add-icon" name="add" />

                                    <div class="add-tab-label">
                                        New custom field
                                    </div>
                                </div>

                                <div>
                                    <div
                                        v-if="searchCustomFieldsResults.length > 0"
                                        class="from-template"
                                    >
                                        Custom fields
                                    </div>

                                    <ds-list-item
                                        v-for="(cField, custIndex) in searchCustomFieldsResults"
                                        :key="cField.id"
                                        :title="cField.name"
                                        border-style="none"
                                        class="list-item-option"
                                        clickable
                                        @click="showAddedCustomField(cField, custIndex, tabIndex, hIndex)"
                                    />

                                    <div v-if="isManageLayoutGroupingUpSystemFieldsEnabled">
                                        <div
                                            v-if="searchGeneralInformationResults.length > 0"
                                            class="from-template"
                                        >
                                            {{ allGroupedFields.generalInformationText }}
                                        </div>

                                        <ds-list-item
                                            v-for="(generalField, generalIndex) in searchGeneralInformationResults"
                                            :key="`generalIndex${generalField.id}`"
                                            :title="generalField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedGeneralInfoField(generalField, generalIndex, tabIndex, hIndex)"
                                        />

                                        <div
                                            v-if="searchEmailAndSocialMediaResults.length > 0"
                                            class="from-template"
                                        >
                                            {{ allGroupedFields.emailAndSocialMediaText }}
                                        </div>

                                        <ds-list-item
                                            v-for="(emailField, emailIndex) in searchEmailAndSocialMediaResults"
                                            :key="`emailIndex${emailField.id}`"
                                            :title="emailField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedEmailAndSocialMediaField(emailField, emailIndex, tabIndex, hIndex)"
                                        />

                                        <div
                                            v-if="searchPhoneAndFaxResults.length > 0"
                                            class="from-template"
                                        >
                                            {{ allGroupedFields.phoneAndFaxText }}
                                        </div>

                                        <ds-list-item
                                            v-for="(phoneField, phoneIndex) in searchPhoneAndFaxResults"
                                            :key="`phoneIndex${phoneField.id}`"
                                            :title="phoneField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedPhoneAndFaxField(phoneField, phoneIndex, tabIndex, hIndex)"
                                        />

                                        <div
                                            v-if="searchAddressFieldsResults.length > 0"
                                            class="from-template"
                                        >
                                            {{ allGroupedFields.addressFieldsText }}
                                        </div>

                                        <ds-list-item
                                            v-for="(addressField, addressIndex) in searchAddressFieldsResults"
                                            :key="`addressIndex2-${addressIndex}`"
                                            :title="addressField"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showGroupedAddressFields(addressField, tabIndex, hIndex)"
                                        />

                                        <div
                                            v-if="searchOtherFieldsResults.length > 0"
                                            class="from-template"
                                        >
                                            {{ allGroupedFields.otherFieldsText }}
                                        </div>

                                        <ds-list-item
                                            v-for="(otherField, otherIndex) in searchOtherFieldsResults"
                                            :key="`otherIndex${otherField.id}`"
                                            :title="otherField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedOtherFields(otherField, otherIndex, tabIndex, hIndex)"
                                        />
                                    </div>

                                    <div v-else>
                                        <div
                                            v-if="searchSystemFieldsResults.length>0"
                                            class="from-template"
                                        >
                                            System fields
                                        </div>

                                        <ds-list-item
                                            v-for="(sField, sysIndex) in searchSystemFieldsResults"
                                            :key="sField.id"
                                            :title="sField.name"
                                            border-style="none"
                                            class="list-item-option"
                                            clickable
                                            @click="showAddedSystemField(sField, sysIndex, tabIndex, hIndex)"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ds-dropdown>
                </ds-card-body>
            </ds-card>

            <div v-if="selectedTab !== '' && !cloneOriginalSystemTabList.includes(selectedTab) && !copyEverythingTabList.includes(selectedTab)">
                <ds-card>
                    <ds-card-header>
                        <div>
                            <ds-text-button
                                button-class="text-button"
                                @click="addHeader"
                            >
                                <ds-icon class="add-icon" name="add-fill" />

                                <span class="add-a-tab-label">
                                    Add a header section
                                </span>
                            </ds-text-button>
                        </div>
                    </ds-card-header>
                </ds-card>
            </div>
        </div>

        <ds-modal
            :is-open="isAddACustomFieldModalOpen"
            :title.sync="modalFieldTitle"
            show-close
            @close="modalCloseForCustomFieldModal"
        >
            <template #header>
                <ds-filled-button
                    :loading="saving"
                    :disabled="isEditFieldSaveEnable"
                    @click="closeAndSaveCustomField"
                >
                    Save
                </ds-filled-button>
            </template>

            <template #default>
                <div>
                    <ds-input-field v-model="addCustomFieldName" label="Field name" />

                    <ds-select-field
                        v-model="addCustomFieldType"
                        :readonly="isFieldEditable"
                        bind-value-only
                        label="Field type"
                        name="Field type"
                        :options="customFieldTypes"
                    />

                    <section v-if="hasOptions">
                        <h6 class="semibold">
                            Build your field
                        </h6>

                        <div class="field-options">
                            <ds-text-area-field
                                v-model="fieldValues"
                                required
                                label="Field Options"
                            />

                            <small>Enter one option per line. Field options will be displayed as a list in the order you create them.</small>

                            <div v-if="hasSettings" class="field-settings">
                                <!-- eslint-disable vue/no-v-html -->
                                <p v-html="'<strong>Settings</strong> (Optional)'" />
                                <!-- eslint-enable vue/no-v-html -->

                                <ds-checkbox
                                    v-model="defaultToFirstOption"
                                    label="Display the first listed option as the default selection."
                                />

                                <small>(If unchecked, the default selection will display the field title, such as “office location.“)</small>
                            </div>
                        </div>
                    </section>
                </div>

                <div class="div-filed-type-info">
                    <ds-icon slot="leading" name="info-circle" />

                    <p class="info-text">
                        Not sure which field type to use? No problem, we can help you
                        <a
                            class="toast-action"
                            href="http://help.infusionsoft.com/userguides/get-started/create-custom-fields/choose-custom-field-types"
                            target="_blank"
                        > choose the right field type.
                        </a>
                    </p>
                </div>
            </template>
        </ds-modal>

        <ds-confirm-dialog
            :is-open="isHeaderLayoutConfirmModalOpen"
            :message="deleteHeaderNameMessage"
            cancel-label="Cancel"
            confirm-label="Ok"
            confirm-button-class="negative"
            destructive
            title="Delete header?"
            @cancel="cancelDeleteConfirmModal"
            @confirm="deleteHeaderSection"
        />

        <ds-confirm-dialog
            :is-open="isFieldLayoutConfirmModalOpen"
            :message="deleteFieldNameMessage"
            cancel-button-class="cancel"
            cancel-label="Cancel"
            confirm-button-class="negative"
            confirm-label="Delete field"
            title="Delete Field?"
            @cancel="cancelDeleteConfirmModal"
            @confirm="deleteCustomFieldsFormDropdown"
        />

        <ds-confirm-dialog
            :is-open="isHeaderFieldLayoutConfirmModalOpen"
            :message="deleteFieldNameMessage"
            cancel-button-class="cancel"
            cancel-label="Cancel"
            confirm-button-class="negative"
            confirm-label="Remove field"
            title="Remove Field?"
            @cancel="cancelDeleteConfirmModal"
            @confirm="deleteLayoutFieldById"
        />
    </div>
</template>
<script>
import axios from 'axios';
import Draggable from 'vuedraggable';
import cloneDeep from 'lodash.clonedeep';
import contactFieldTypes from '../contactFieldTypes';

const RENDER_LIMIT = 1000;

export default {
    components: {
        Draggable,
    },

    props: {
        userId: [String, Number],
        contactCustomizableLayoutObj: Object,
        selectedTabName: String,
        showCampaignStealthTab: Boolean,
    },

    data() {
        return {
            fieldValues: null,
            contactFieldTypes,
            customFieldValues: [],
            addCustomFieldType: '',
            fieldIndex: 0,
            newCustomFieldId: {},
            updateCustomFieldName: '',
            updateCustomFieldType: '',
            defaultToFirstOption: false,
            isEditFieldSaveEnable: false,
            isFieldEditable: false,
            deleteHeaderNameMessage: '',
            deleteFieldNameMessage: '',
            headerFieldId: '',
            fieldDataToDelete: {},
            headerID: '',
            moreOptions: true,
            saving: false,
            isAddHeaderEnable: false,
            selectedTab: 'Contact Info',
            moreMap: new Map(),
            headerName: '',
            layoutNewFields: {},
            allFieldNames: [],
            layoutHeader: {},
            addCustomFieldName: '',
            customLayoutField: {},
            headerIndex: 0,
            modalFieldTitle: 'Create a new field',
            customFieldData: {},
            customFieldTypes: [],
            customFieldTypesObject: [],
            searchCriteria: '',
            aliasSytemFields: [],
            aliasCustomFields: [],
            tabIndex: 0,
            moreOptionHeaderName: '',
            enableAddHeader: false,
            headerList: [],
            originalSystemTabList: ['Contact Info', 'Notes', 'Tags', 'Money', 'Tasks', 'Appointments', 'Form submissions', 'Emails', 'Campaigns', 'Opportunities', 'Scored activities', 'Files', 'Linked contacts', 'Follow-up sequences', 'Access privileges', 'Referral partner'],
            copyEverythingTabList: ['Notes', 'Tags', 'Money', 'Tasks', 'Form submissions', 'Scored activity', 'Files', 'Linked contacts', 'Follow-up sequences', 'Web profile', 'Access privileges', 'Referral partner'],
            cloneOriginalSystemTabList: [],
            cloneSystemFields: {},
            cloneCustomFields: {},
            emitGetAll: false,
            saveEvent: '',
            contactCustomizableLayout: {},
            layoutObj: {},
            generalInformation: [],
            storeGeneralInfo: [],
            emailAndSocialMedia: [],
            storeEmailInfo: [],
            phoneAndFax: [],
            storePhoneInfo: [],
            billingAddressInfo: [],
            shippingAddressInfo: [],
            optionalAddressInfo: [],
            billingAddressData: [],
            shippingAddressData: [],
            optionalAddressData: [],
            fieldsType: 'otherFields',
            addressMainFields: [],
            otherFields: [],
            storeOtherFields: [],
            contactFieldGroupIds: {
                groupId1: true,
                groupId2: true,
                groupId4: true,
                groupId5: true,
                groupId6: true,
                groupId7: true,
                groupId8: true,
            },
            allGroupedFields: {
                generalInformationText: 'General Information',
                emailAndSocialMediaText: 'Email And Social media',
                phoneAndFaxText: 'Phone And Fax',
                addressFieldsText: 'Address Fields',
                otherFieldsText: 'Other Fields',
            },
            addressFieldNames: {
                billingAddress: 'Billing address',
                shippingAddress: 'Shipping address',
                optionalAddress: 'Optional address',

            },
            featureFlagValues: [],
            isRemoveDeleteFieldOptionEnabled: false,
            isRemoveHeaderSectionIfTitleIsEmptyEnabled: false,
            isManageLayoutCantAddFieldEnabled: false,
            isRemoveConfirmationBoxEnabled: false,
            isAddACustomFieldModalOpen: false,
            isManageLayoutGroupingUpSystemFieldsEnabled: false,
            isFS52101DuplicateCustomFieldsEnabled: false,
            standardFields: [],
            isHeaderLayoutConfirmModalOpen: false,
            isFieldLayoutConfirmModalOpen: false,
            isHeaderFieldLayoutConfirmModalOpen: false,
        };
    },

    beforeDestroy() {
        this.$root.$off('LAYOUT_DISPLAY_DETAILS', this.getLayoutDisplayDetails);
        this.$root.$off('LAYOUT_DISPLAY_DETAILS_CUSTOM_FIELDS', this.getLayoutDisplayDetailsCustomFields);
    },

    mounted() {
        this.$root.$on('LAYOUT_DISPLAY_DETAILS', this.getLayoutDisplayDetails);
        this.$root.$on('LAYOUT_DISPLAY_DETAILS_CUSTOM_FIELDS', this.getLayoutDisplayDetailsCustomFields);
    },

    created() {
        this.getFeatureFlagValue();
        this.displayCampaignStealth();
        this.emitGetAll = true;
        this.selectedTab = this.selectedTabName;
        this.contactCustomizableLayout = this.contactCustomizableLayoutObj;
        this.cloneOriginalSystemTabList = cloneDeep(this.originalSystemTabList);
        this.cloneOriginalSystemTabList.splice(0, 1);
        this.tabSelectedLayoutDetails(this.tabIndex, this.contactCustomizableLayout);
        this.showHeaderSection();
        this.getLayoutCustomFieldsList();
        this.getLayoutFieldsList();
        this.getFieldTypeName();
    },

    watch: {
        fieldValues(values) {
            if (this.hasOptions) {
                this.customFieldValues = values && values.length
                    ? values.replace(/,/g, '').trim().split('\n').filter((value) => value.length > 0) : [];
            }
        },
    },

    computed: {
        hasOptions() {
            const { addCustomFieldType } = this;

            return addCustomFieldType && contactFieldTypes.CUSTOM[addCustomFieldType.replace(' ', '')]
                ? contactFieldTypes.CUSTOM[addCustomFieldType.replace(' ', '')].hasOptions : false;
        },

        hasSettings() {
            const { addCustomFieldType } = this;

            return addCustomFieldType
                ? contactFieldTypes.CUSTOM[addCustomFieldType.replace(' ', '')].hasSettings : false;
        },

        searchConditions() {
            return new RegExp(this.searchCriteria, 'gi');
        },

        searchFieldsData() {
            return (searchData) => {
                if (this.searchCriteria) {
                    const searchResults = [];

                    for (let cIdx = 0; cIdx < searchData.length && searchResults.length < RENDER_LIMIT; cIdx++) {
                        if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                            if (searchData[cIdx].name !== null && searchData[cIdx].name.match(this.searchConditions)) {
                                searchResults.push(searchData[cIdx]);
                            } else if (this.allGroupedFields.generalInformationText.toLowerCase().includes(this.searchCriteria.toLowerCase()) && searchData[cIdx].groupName === 'General') {
                                searchResults.push(searchData[cIdx]);
                            } else if (this.allGroupedFields.emailAndSocialMediaText.toLowerCase().includes(this.searchCriteria.toLowerCase()) && searchData[cIdx].groupName === 'Social') {
                                searchResults.push(searchData[cIdx]);
                            } else if (this.allGroupedFields.phoneAndFaxText.toLowerCase().includes(this.searchCriteria.toLowerCase()) && searchData[cIdx].groupName === 'Phone and email') {
                                searchResults.push(searchData[cIdx]);
                            } else if (this.allGroupedFields.otherFieldsText.toLowerCase().includes(this.searchCriteria.toLowerCase()) && searchData[cIdx].groupName === 'Additional info') {
                                searchResults.push(searchData[cIdx]);
                            } else if ('Custom Fields'.toLowerCase().includes(this.searchCriteria.toLowerCase()) && searchData[cIdx].groupName === 'Custom fields') {
                                searchResults.push(searchData[cIdx]);
                            } else if (this.allGroupedFields.addressFieldsText.toLowerCase().includes(this.searchCriteria.toLowerCase()) && (searchData[cIdx].groupName === 'Billing address' || searchData[cIdx].groupName === 'Shipping address' || searchData[cIdx].groupName === 'Optional address')) {
                                searchResults.push(searchData[cIdx]);
                            }
                        } else if (searchData[cIdx].name !== null && searchData[cIdx].name.match(this.searchConditions)) {
                            searchResults.push(searchData[cIdx]);
                        }
                    }

                    return searchResults;
                }

                if (this.searchCriteria) {
                    return searchData.filter(({ label }) => label.name.match(this.searchConditions));
                }

                return searchData;
            };
        },

        searchSystemFieldsResults() {
            const aliasSystem = this.aliasSytemFields && this.aliasSytemFields.length > 0 ? this.aliasSytemFields.map((x) => x) : [];

            return this.searchFieldsData(aliasSystem);
        },

        searchCustomFieldsResults() {
            const aliasCustom = this.aliasCustomFields && this.aliasCustomFields.length > 0 ? this.aliasCustomFields.map((x) => x) : [];

            return this.searchFieldsData(aliasCustom);
        },

        searchGeneralInformationResults() {
            const aliasGeneralInfo = this.generalInformation && this.generalInformation.length > 0 ? this.generalInformation.map((x) => x) : [];

            return this.searchFieldsData(aliasGeneralInfo);
        },

        searchEmailAndSocialMediaResults() {
            const aliasEmailAndSocialMedia = this.emailAndSocialMedia && this.emailAndSocialMedia.length > 0 ? this.emailAndSocialMedia.map((x) => x) : [];

            return this.searchFieldsData(aliasEmailAndSocialMedia);
        },

        searchPhoneAndFaxResults() {
            const aliasPhoneAndFax = this.phoneAndFax && this.phoneAndFax.length > 0 ? this.phoneAndFax.map((x) => x) : [];

            return this.searchFieldsData(aliasPhoneAndFax);
        },

        searchAddressFieldsResults() {
            const aliasaddressFields = this.addressMainFields?.filter((addressField) => {
                return addressField?.toLowerCase().includes(this.searchCriteria?.trim()?.toLowerCase());
            });

            return aliasaddressFields;
        },

        searchOtherFieldsResults() {
            const aliasOtherFields = this.otherFields && this.otherFields.length > 0 ? this.otherFields.map((x) => x) : [];

            return this.searchFieldsData(aliasOtherFields);
        },
    },

    methods: {
        closeAndSaveCustomField () {
            if (this.isFS52101DuplicateCustomFieldsEnabled) {
                this.saving = true;
                this.isEditFieldSaveEnable = true;
            }
            this.addACustomField();
        },
        displayCampaignStealth() {
            if (this.showCampaignStealthTab) {
                this.originalSystemTabList.push('Campaigns stealth');
                this.copyEverythingTabList.push('Campaigns stealth');
            }
        },

        getLayoutDisplayDetails(data) {
            this.headerName = '';
            this.contactCustomizableLayout = data.contactCustomizableLayout;
            this.tabIndex = data.tabIndex;
            this.getLayoutFieldsList();
            this.getLayoutCustomFieldsList();
            this.tabSelectedLayoutDetails(this.tabIndex, this.contactCustomizableLayout);
        },

        getLayoutDisplayDetailsCustomFields(data) {
            this.contactCustomizableLayout = data.contactCustomizableLayout;
            this.tabIndex = data.tabIndex;
            this.getLayoutCustomFieldsList();

            if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                this.aliasSytemFields = this.standardFields;
            } else {
                this.aliasSytemFields = this.standardFields.filter((res) => !(res.customFieldDataType === 'Person Notes' || res.customFieldDataType === 'Account Summary And Lead Score'));
            }
            this.aliasCustomFields = cloneDeep(this.cloneCustomFields);
            this.getStandardFieldName();
            this.tabSelectedLayoutDetails(this.tabIndex, this.contactCustomizableLayout);
        },

        tabSelectedLayoutDetails(tabIndex, data) {
            tabIndex = Number(tabIndex) ? Number(tabIndex) : 0;
            this.selectedTab = (data.layoutComponents !== undefined && data.layoutComponents[tabIndex] && data.layoutComponents[tabIndex].name !== undefined) ? data.layoutComponents[tabIndex].name : '';

            this.sendTabEvent(this.selectedTab, this.tabIndex);
            this.showHeaderSection();
        },

        openHeaderDeleteConfirmModal(headerId) {
            this.headerID = headerId;
            this.deleteHeaderNameMessage = 'This action only deletes the headers within the tab, the fields within this Header will NOT be deleted?';
            this.isHeaderLayoutConfirmModalOpen = true;
        },

        openToggleFieldDeleteConfirmModal(field) {
            this.fieldDataToDelete = field;
            this.deleteFieldNameMessage = 'Deleting this field also deletes any data saved to this field. This action cannot be undone.';
            this.isFieldLayoutConfirmModalOpen = true;
        },

        openToggleFieldRemoveConfirmModal(headerFieldId) {
            this.headerFieldId = headerFieldId;

            if (this.isRemoveConfirmationBoxEnabled) {
                this.deleteLayoutFieldById();
            } else {
                this.deleteFieldNameMessage = 'Removing this field WILL NOT delete any data saved to this field. Your changes will only be applied to the custom view you are working on.';
                this.isHeaderFieldLayoutConfirmModalOpen = true;
            }
        },

        removeHeaderSectionIfTitleIsEmpty() {
            this.isAddHeaderEnable = false;
        },

        cancelDeleteConfirmModal() {
            this.isHeaderLayoutConfirmModalOpen = false;
            this.isFieldLayoutConfirmModalOpen = false;
            this.isHeaderFieldLayoutConfirmModalOpen = false;
            this.fieldDataToDelete = {};
            this.headerFieldId = '';
            this.headerID = '';
        },

        saveContactLayoutDetails() {
            if (this.saveEvent === 'FIELD') {
                this.modalCloseForCustomFieldModal();
            }
            this.layoutObj.contactCustomizableLayout = this.contactCustomizableLayout;
            this.layoutObj.saveEvent = this.saveEvent;

            if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                if (this.fieldsType === 'otherFields') {
                    this.$root.$emit('LAYOUT_SAVE_DETAILS', this.layoutObj);
                }
            } else {
                this.$root.$emit('LAYOUT_SAVE_DETAILS', this.layoutObj);
            }
        },

        async getLayoutFieldsList() {
            this.generalInformation = [];
            this.storeGeneralInfo = [];
            this.emailAndSocialMedia = [];
            this.storeEmailInfo = [];
            this.phoneAndFax = [];
            this.storePhoneInfo = [];
            this.billingAddressInfo = [];
            this.shippingAddressInfo = [];
            this.optionalAddressInfo = [];
            this.billingAddressData = [];
            this.shippingAddressData = [];
            this.optionalAddressData = [];
            this.otherFields = [];
            this.storeOtherFields = [];

            try {
                const response = await axios.get('/app/contact/standardfields');

                this.cloneSystemFields = cloneDeep(response.data);
                this.standardFields = response.data;

                if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                    this.aliasSytemFields = this.standardFields;
                } else {
                    this.aliasSytemFields = this.standardFields.filter((res) => !(res.customFieldDataType === 'Person Notes' || res.customFieldDataType === 'Account Summary And Lead Score'));
                }
                this.groupingSystemFields();
                this.getStandardFieldName();
            } catch (error) {
                this.$error({ message: 'error occurred while getting contact Layout fields List' });
            }
        },

        async  groupingSystemFields() {
            this.aliasSytemFields.forEach((groupedFields) => {
                const name = groupedFields.standardFieldName.replaceAll('_', ' ').toLowerCase();

                groupedFields.name = name.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter.toUpperCase());

                switch (groupedFields.groupName) {
                case 'General':
                    this.contactFieldGroupIds.groupId1 = this.generalInformation.some((info) => {
                        return info.customFieldDataType === 'contacttype';
                    });

                    if (!this.contactFieldGroupIds.groupId1) {
                        this.generalInformation.push(groupedFields);
                        this.storeGeneralInfo.push(groupedFields);
                    }
                    break;
                case 'Phone and email':
                    this.contactFieldGroupIds.groupId2 = this.phoneAndFax.some((info) => {
                        return info.customFieldDataType === 'email';
                    });

                    if (!this.contactFieldGroupIds.groupId2) {
                        this.phoneAndFax.push(groupedFields);
                        this.storePhoneInfo.push(groupedFields);
                    }
                    break;
                case 'Social':
                    this.contactFieldGroupIds.groupId4 = this.emailAndSocialMedia.some((info) => {
                        return info.customFieldDataType === 'linkedin';
                    });

                    if (!this.contactFieldGroupIds.groupId4) {
                        this.emailAndSocialMedia.push(groupedFields);
                        this.storeEmailInfo.push(groupedFields);
                    }
                    break;
                case 'Billing address':
                    this.contactFieldGroupIds.groupId5 = this.billingAddressInfo.some((info) => {
                        return info.customFieldDataType === 'postalcode';
                    });

                    if (!this.contactFieldGroupIds.groupId5) {
                        this.billingAddressInfo.push(groupedFields);
                    }
                    break;
                case 'Shipping address':
                    this.contactFieldGroupIds.groupId6 = this.shippingAddressInfo.some((info) => {
                        return info.customFieldDataType === 'postalcode2';
                    });

                    if (!this.contactFieldGroupIds.groupId6) {
                        this.shippingAddressInfo.push(groupedFields);
                    }
                    break;
                case 'Optional address':
                    this.contactFieldGroupIds.groupId7 = this.optionalAddressInfo.some((info) => {
                        return info.customFieldDataType === 'postalcode3';
                    });

                    if (!this.contactFieldGroupIds.groupId7) {
                        this.optionalAddressInfo.push(groupedFields);
                    }
                    break;
                case 'Additional info':
                    this.contactFieldGroupIds.groupId8 = this.otherFields.some((info) => {
                        return info.customFieldDataType === 'Account Summary And Lead Score';
                    });

                    if (!this.contactFieldGroupIds.groupId8) {
                        this.otherFields.push(groupedFields);
                        this.storeOtherFields.push(groupedFields);
                    }
                    break;
                default:
                    break;
                }
            });
        },

        async getLayoutCustomFieldsList() {
            this.allContactCustomFields = {};

            try {
                const response = await axios.get('/app/contact/getCustomfields');

                this.cloneCustomFields = cloneDeep(response.data);
                this.aliasCustomFields = response.data;
                this.getAllCustomFieldNames();
            } catch (error) {
                this.$error({ message: 'error occurred while getting contact Layout Custom fields List' });
            }
        },

        showHeaderSection() {
            this.moreMap = new Map();

            if (this.tabIndex !== '') {
                this.contactCustomizableLayout.layoutComponents && this.contactCustomizableLayout.layoutComponents[this.tabIndex] && this.contactCustomizableLayout.layoutComponents[this.tabIndex].components && this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.map((headerDetails) => {
                    return this.moreMap.set(headerDetails.name, true);
                });
            }
        },

        clearSearch() {
            this.searchCriteria = '';
        },

        addHeader() {
            this.isAddHeaderEnable = true;

            if (this.isManageLayoutCantAddFieldEnabled) {
                setTimeout(() => {
                    const data = document.querySelector('[placeholder="untitled Header"]');
                    const close = data.closest('#editing-container');

                    close.style.display = 'block';
                    close.previousSibling.style.display = 'none';
                    document.querySelector('[placeholder="untitled Header"]').focus();
                }, 10);
            }
        },

        async deleteHeaderSection() {
            try {
                await axios.delete(`/app/contactLayout/field/${this.headerID}`);
                this.isHeaderLayoutConfirmModalOpen = false;
                this.$toast({ message: 'Header Section removed successfully' });

                this.saveEvent = 'HEADER';
                this.emitGetAll = true;
                this.headerID = '';
                this.$root.$emit('LAYOUT_GET_ALL', `${this.contactCustomizableLayout.name}#*_#${this.saveEvent}#*_#${this.tabIndex}`);
            } catch (error) {
                this.$error({ message: 'error occurred while deleting header' });
            }
        },

        addHeaderNames(index, name) {
            if (index === null) {
                this.layoutHeader.id = 0;
                this.layoutHeader.contentType = '';

                if (name === null && this.headerName === '' && this.isManageLayoutCantAddFieldEnabled) {
                    name = 'untitledHeader';
                    this.layoutHeader.name = name;
                } else {
                    this.layoutHeader.name = this.headerName;
                }
                this.layoutHeader.order = this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length;
                this.layoutHeader.componentType = 'HEADER';
                this.layoutHeader.components = [];

                this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.push(this.layoutHeader);
            } else {
                this.headerIndex = index;
                this.contactCustomizableLayout.layoutComponents[this.tabIndex].components[index].name = name;
            }
            this.layoutHeader = {};
            this.isAddHeaderEnable = false;
            this.saveEvent = 'HEADER';

            if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                this.fieldsType = 'otherFields';
            }

            if (this.headerName !== '') {
                this.saveContactLayoutDetails();
            }
        },

        isCustomOrSystemField(customField) {
            if (customField.contentType && customField.contentType.includes('CUSTOM')) {
                const type = customField.contentType.split('_');

                return `(custom field type: ${type[1]})`;
            }

            return `(system field: ${customField.name.length > 20 ? `${customField.name.substring(0, 20)} ...` : customField.name})`;
        },

        updateHeaderOrder(tabIndex) {
            this.headerList = this.headerList.map((item, index) => {
                item.order = index;

                return item;
            });
            this.contactCustomizableLayout.layoutComponents[tabIndex].components = this.headerList;
            this.saveEvent = 'HEADER';

            if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                this.fieldsType = 'otherFields';
            }
            this.saveContactLayoutDetails();
        },

        editCustomField(customField, tabIndex, hIndex, fIndex) {
            this.customFieldData = customField;
            this.modalFieldTitle = 'Edit custom field';
            this.addCustomFieldName = customField.name;
            this.updateCustomFieldName = customField.name;
            this.updateCustomFieldType = customField.contentType;
            this.fieldIndex = fIndex;
            const type = customField.contentType.split('_');
            const fieldType = type[1];

            if (type[0] === 'CUSTOM') {
                this.isFieldEditable = true;
                this.isEditFieldSaveEnable = false;
            } else {
                this.modalFieldTitle = 'Edit system field';
                this.isFieldEditable = false;
                this.isEditFieldSaveEnable = false;
            }

            const fieldData = this.cloneCustomFields.filter((x) => {
                return (x.name === this.updateCustomFieldName) && (x.id === Number(type[2]));
            }).map((find) => find.dataFormFieldEntity);

            const isDefaultToFirst = fieldData.map((value) => value.values)[0];

            fieldData.forEach((item) => {
                if (item.defaultValue !== null) {
                    this.defaultToFirstOption = true;
                }
            });
            this.fieldValues = isDefaultToFirst;
            this.addCustomFieldType = fieldType;
            this.addACustomFieldModal(tabIndex, hIndex);
        },

        addACustomFieldModal(tabIndex, hIndex) {
            this.tabIndex = tabIndex;

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.headerIndex = this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length;
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.addCustomFieldType = this.addCustomFieldType === '' ? this.customFieldTypes[0].value : this.addCustomFieldType;
            this.isAddACustomFieldModalOpen = true;
        },

        modalCloseForCustomFieldModal() {
            this.addCustomFieldName = '';
            this.addCustomFieldType = '';
            this.updateCustomFieldName = '';
            this.updateCustomFieldType = '';
            this.fieldValues = null;
            this.customFieldValues = [];
            this.defaultToFirstOption = false;
            this.modalFieldTitle = 'Create a new field';
            this.isFieldEditable = false;
            this.isEditFieldSaveEnable = false;

            if (this.isFS52101DuplicateCustomFieldsEnabled) {
                this.saving = false;
            }
            this.isAddACustomFieldModalOpen = false;
        },

        addACustomField() {
            const customFieldDataForm = {};

            customFieldDataForm.name = this.addCustomFieldName;
            customFieldDataForm.groupId = 3;
            customFieldDataForm.customFieldDataType = Object.keys(this.customFieldTypesObject)[Object.values(this.customFieldTypesObject).indexOf(this.addCustomFieldType)];
            this.customFieldValues = this.customFieldValues.length ? this.customFieldValues.map((values) => values.replace(/\r/g, '')) : [];
            customFieldDataForm.values = this.customFieldValues;
            customFieldDataForm.defaultToFirstOption = this.defaultToFirstOption;

            if (this.modalFieldTitle === 'Create a new field') {
                this.saveCustomFieldsInDataFormField(customFieldDataForm);
            } else {
                this.contactCustomizableLayout.layoutComponents[this.tabIndex].components[this.headerIndex].components[this.fieldIndex].name = this.addCustomFieldName;

                customFieldDataForm.visible = true;
                customFieldDataForm.customField = true;
                const customFieldId = this.updateCustomFieldType.split('_');
                const customId = this.cloneCustomFields.filter((x) => {
                    return (x.name === this.updateCustomFieldName) && (x.id === Number(customFieldId[2]));
                }).map((find) => find.id);

                this.updateCustomField(customId, customFieldDataForm);
            }
        },

        async updateCustomField(id, customFieldDataForm) {
            try {
                await axios.put(`/app/contact/updateCustomField/${id}`, customFieldDataForm);
                this.getLayoutCustomFieldsList();
                const customFieldUpdate = {};

                customFieldUpdate.updatedCustomFieldName = this.addCustomFieldName;
                customFieldUpdate.lastCustomFieldName = this.updateCustomFieldName;
                customFieldUpdate.contentType = this.updateCustomFieldType;
                this.updateCustomFieldInContactLayout(customFieldUpdate);
            } catch (error) {
                this.$error({ message: 'error occurred while updating custom field' });
            }
        },

        async updateCustomFieldInContactLayout(fieldUpdate) {
            try {
                await axios.put('/app/contactLayout/layout/updateCustomField', fieldUpdate);
                this.emitGetAll = true;

                this.modalCloseForCustomFieldModal();
                this.updateFieldOrder(this.tabIndex, this.headerIndex);
            } catch (error) {
                this.$error({ message: 'error occurred while updating custom field' });
            }
        },

        showAddedSystemField(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.aliasSytemFields.splice(index, 1);

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showAddedGeneralInfoField(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.generalInformation.splice(index, 1);
            this.fieldsType = 'otherFields';

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showAddedEmailAndSocialMediaField(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.emailAndSocialMedia.splice(index, 1);
            this.fieldsType = 'otherFields';

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showAddedPhoneAndFaxField(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.phoneAndFax.splice(index, 1);
            this.fieldsType = 'otherFields';

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showGroupedAddressFields(field, tabIndex, hIndex) {
            switch (field) {
            case this.addressFieldNames.billingAddress:
                this.showAddressFields(this.billingAddressInfo, tabIndex, hIndex);
                break;
            case this.addressFieldNames.shippingAddress:
                this.showAddressFields(this.shippingAddressInfo, tabIndex, hIndex);
                break;
            case this.addressFieldNames.optionalAddress:
                this.showAddressFields(this.optionalAddressInfo, tabIndex, hIndex);
                break;
            default:
                break;
            }
        },

        showAddressFields(filedsData, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.fieldsType = 'addressFields';
            filedsData.forEach((info) => {
                if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                    this.showAddedField(info, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
                } else {
                    this.showAddedField(info, tabIndex, hIndex);
                }
            });
            this.$root.$emit('LAYOUT_SAVE_DETAILS', this.layoutObj);

            this.headerIndex = '';
        },

        addAddressField(tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled && this.headerName !== '') {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.optionalAddressData = [];
            this.shippingAddressData = [];
            this.billingAddressData = [];
            this.contactCustomizableLayout.layoutComponents[tabIndex].components.forEach((checkOnlyAddress) => {
                this.checkAllTabAddress(checkOnlyAddress.components);
            });

            if (!this.billingAddressData.includes(true)) {
                if (!this.addressMainFields.includes(this.addressFieldNames.billingAddress)) {
                    this.addressMainFields.push(this.addressFieldNames.billingAddress);
                }
            } else {
                this.addressMainFields.forEach((adrress) => {
                    if (adrress === this.addressFieldNames.billingAddress) {
                        this.addressMainFields.splice(adrress, 1);
                    }
                });
            }

            if (!this.optionalAddressData.includes(true)) {
                if (!this.addressMainFields.includes(this.addressFieldNames.optionalAddress)) {
                    this.addressMainFields.push(this.addressFieldNames.optionalAddress);
                }
            } else {
                this.addressMainFields.forEach((adrress) => {
                    if (adrress === this.addressFieldNames.optionalAddress) {
                        this.addressMainFields.splice(adrress, 1);
                    }
                });
            }

            if (!this.shippingAddressData.includes(true)) {
                if (!this.addressMainFields.includes(this.addressFieldNames.shippingAddress)) {
                    this.addressMainFields.push(this.addressFieldNames.shippingAddress);
                }
            } else {
                this.addressMainFields.forEach((adrress) => {
                    if (adrress === this.addressFieldNames.shippingAddress) {
                        this.addressMainFields.splice(adrress, 1);
                    }
                });
            }
            this.checkAllFields(this.contactCustomizableLayout.layoutComponents[tabIndex].components);

            this.headerIndex = '';
        },

        checkAllTabAddress(allTabAddress) {
            const optionalAddress = allTabAddress.some((checkField) => {
                return checkField.name === 'Postal Code3' || checkField.name === 'Address3 Street1' || checkField.name === 'Address3 Street2' || checkField.name === 'State3' || checkField.name === 'Country3' || checkField.name === 'City3';
            });

            this.optionalAddressData.push(optionalAddress);

            const billingAddress = allTabAddress.some((checkField) => {
                return checkField.name === 'Postal Code' || checkField.name === 'Street Address1' || checkField.name === 'Street Address2' || checkField.name === 'State' || checkField.name === 'Country' || checkField.name === 'City';
            });

            this.billingAddressData.push(billingAddress);

            const shippingAddress = allTabAddress.some((checkField) => {
                return checkField.name === 'Postal Code2' || checkField.name === 'Address2 Street1' || checkField.name === 'Address2 Street2' || checkField.name === 'State2' || checkField.name === 'Country2' || checkField.name === 'City2';
            });

            this.shippingAddressData.push(shippingAddress);
        },

        showAddedOtherFields(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.otherFields.splice(index, 1);
            this.fieldsType = 'otherFields';

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showAddedCustomField(field, index, tabIndex, hIndex) {
            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.addHeaderNames(null, null);
            } else {
                this.headerIndex = hIndex;
            }
            this.aliasCustomFields.splice(index, 1);

            if (this.isManageLayoutGroupingUpSystemFieldsEnabled) {
                this.fieldsType = 'otherFields';
            }
            field.standardFieldName = `CUSTOM_${field.customFieldDataType}_${field.id}`;

            if (hIndex === undefined && this.isManageLayoutCantAddFieldEnabled) {
                this.showAddedField(field, tabIndex, this.contactCustomizableLayout.layoutComponents[this.tabIndex].components.length - 1);
            } else {
                this.showAddedField(field, tabIndex, hIndex);
            }
            this.headerIndex = '';
        },

        showAddedField(field, tabIndex, hIndex) {
            this.layoutNewFields.id = 0;
            this.layoutNewFields.contentType = field.standardFieldName;
            this.layoutNewFields.name = field.name;
            this.layoutNewFields.order = field.order;
            this.layoutNewFields.componentType = 'FIELD';
            this.layoutNewFields.components = [];
            this.contactCustomizableLayout.layoutComponents[tabIndex].components[hIndex].components.push(this.layoutNewFields);
            this.layoutNewFields = {};
            this.updateFieldOrder(tabIndex, hIndex);
        },

        checkAllFields(fieldsData) {
            this.generalInformation = [];
            this.storeGeneralInfo.forEach((generalInfo) => {
                this.generalInformation.push(generalInfo);
            });
            this.emailAndSocialMedia = [];
            this.storeEmailInfo.forEach((emailInfo) => {
                this.emailAndSocialMedia.push(emailInfo);
            });
            this.phoneAndFax = [];
            this.storePhoneInfo.forEach((phoneInfo) => {
                this.phoneAndFax.push(phoneInfo);
            });
            this.otherFields = [];
            this.storeOtherFields.forEach((otherInfo) => {
                this.otherFields.push(otherInfo);
            });
            fieldsData.forEach((components) => {
                if (components.components.length > 0) {
                    components.components.forEach((info) => {
                        this.generalInformation.forEach((fields, g) => {
                            if (info.name === fields.name) {
                                this.generalInformation.splice(g, 1);
                            }
                        });
                    });
                }
            });
            fieldsData.forEach((components) => {
                if (components.components.length > 0) {
                    components.components.forEach((info) => {
                        this.emailAndSocialMedia.forEach((fields, e) => {
                            if (info.name === fields.name) {
                                this.emailAndSocialMedia.splice(e, 1);
                            }
                        });
                    });
                }
            });
            fieldsData.forEach((components) => {
                if (components.components.length > 0) {
                    components.components.forEach((info) => {
                        this.phoneAndFax.forEach((fields, p) => {
                            if (info.name === fields.name) {
                                this.phoneAndFax.splice(p, 1);
                            }
                        });
                    });
                }
            });
            fieldsData.forEach((components) => {
                if (components.components.length > 0) {
                    components.components.forEach((info) => {
                        this.otherFields.forEach((fields, o) => {
                            if (info.name === fields.name) {
                                this.otherFields.splice(o, 1);
                            }
                        });
                    });
                }
            });
        },

        async saveCustomFieldsInDataFormField(customFieldData) {
            try {
                const successMessage = 'field created successfully';

                const response = await axios.post('/app/contact/saveCustomfields', customFieldData);

                this.newCustomFieldId = response.data.id;

                this.customLayoutField.name = this.addCustomFieldName;
                this.customLayoutField.contentType = `CUSTOM_${this.addCustomFieldType}_${this.newCustomFieldId}`;
                this.customLayoutField.componentType = 'FIELD';
                this.customLayoutField.order = this.contactCustomizableLayout.layoutComponents[this.tabIndex].components[this.headerIndex].components.length;
                this.contactCustomizableLayout.layoutComponents[this.tabIndex].components[this.headerIndex].components.push(this.customLayoutField);

                this.modalCloseForCustomFieldModal();
                this.customLayoutField = {};
                this.emitGetAll = true;
                this.updateFieldOrder(this.tabIndex, this.headerIndex);
                this.getLayoutCustomFieldsList();
                this.$toast({ message: successMessage });
            } catch (error) {
                this.$error({ message: 'error occurred while adding custom field to data field' });

                if (this.isFS52101DuplicateCustomFieldsEnabled) {
                    this.isEditFieldSaveEnable = false;
                    this.saving = false;
                }
            }
        },

        async deleteCustomFieldsFormDropdown() {
            const customFieldId = this.fieldDataToDelete.contentType.split('_');
            const customId = this.cloneCustomFields.filter((x) => {
                return (x.name === this.fieldDataToDelete.name) && (x.id === Number(customFieldId[2]));
            }).map((find) => find.id);

            this.headerFieldId = this.fieldDataToDelete.id;

            try {
                const successMessage = 'field deleted successfully';

                await axios.delete(`/app/contact/deleteCustomField/${customId}`);

                this.isFieldLayoutConfirmModalOpen = false;

                this.$toast({ message: successMessage });
                this.deleteCustomFieldFromContactLayoutComponent();
            } catch (error) {
                this.$error({ message: 'error occurred while deleting custom field ' });
            }
        },

        async deleteCustomFieldFromContactLayoutComponent() {
            try {
                const successMessage = 'field removed successfully';


                this.fieldDataToDelete.contentType = this.fieldDataToDelete.contentType.replace('/', '-');
                await axios.delete(`/app/contactLayout/layout/deleteCustomField/${this.fieldDataToDelete.name}/${this.fieldDataToDelete.contentType}`);

                this.$toast({ message: successMessage });
                this.saveEvent = 'FIELD';
                this.emitGetAll = true;
                this.headerFieldId = '';
                this.fieldDataToDelete = {};
                this.$root.$emit('LAYOUT_GET_ALL', `${this.contactCustomizableLayout.name}#*_#${this.saveEvent}#*_#${this.tabIndex}`);
            } catch (error) {
                this.$error({ message: 'error occurred while removing custom field ' });
            }
        },

        async deleteLayoutFieldById() {
            const successMessage = 'field removed successfully';

            try {
                await axios.delete(`/app/contactLayout/field/${this.headerFieldId}`);
                this.isHeaderFieldLayoutConfirmModalOpen = false;
                this.$toast({ message: successMessage });
                this.saveEvent = 'FIELD';
                this.headerFieldId = '';
                this.fieldDataToDelete = {};
                this.$root.$emit('LAYOUT_GET_ALL', `${this.contactCustomizableLayout.name}#*_#${this.saveEvent}#*_#${this.tabIndex}`);
            } catch (error) {
                this.$error({ message: 'error occured while deleting field' });
            }
        },

        async getFieldTypeName() {
            try {
                const response = await axios.get('/app/contact/layout/getFieldType');

                this.customFieldTypesObject = response.data;

                const customTypes = Object.values(response.data);

                this.customFieldTypes = Object.keys(customTypes).map((key) => {
                    return { label: customTypes[key], value: customTypes[key] };
                }).sort((prev, next) => prev.label.localeCompare(next.label));
            } catch (error) {
                this.$error({ message: 'error occurred while loading custom field types ' });
            }
        },

        updateFieldOrder(tabIndex, hIndex) {
            this.tabIndex = tabIndex;
            this.headerIndex = hIndex;
            this.contactCustomizableLayout.layoutComponents[tabIndex].components[hIndex].components = this.contactCustomizableLayout.layoutComponents[tabIndex].components[hIndex].components.map((item, index) => {
                item.order = index;

                return item;
            });
            this.saveEvent = 'FIELD';
            this.saveContactLayoutDetails();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/contactLayout/getFeatureFlags');

                this.featureFlagValues = response.data;
                this.isRemoveDeleteFieldOptionEnabled = this.featureFlagValues.isRemoveDeleteFieldOptionEnabled;
                this.isRemoveHeaderSectionIfTitleIsEmptyEnabled = this.featureFlagValues.isRemoveHeaderSectionIfTitleIsEmptyEnabled;
                this.isManageLayoutCantAddFieldEnabled = this.featureFlagValues.isManageLayoutCantAddFieldEnabled;
                this.isRemoveConfirmationBoxEnabled = this.featureFlagValues.isRemoveConfirmationBoxEnabled;
                this.isManageLayoutGroupingUpSystemFieldsEnabled = this.featureFlagValues.isManageLayoutGroupingUpSystemFieldsEnabled;
                this.isFS52101DuplicateCustomFieldsEnabled = this.featureFlagValues.isFS52101DuplicateCustomFieldsEnabled;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },


        toggleHeaderMoreOptions(moreOptionValue) {
            this.moreOptionHeaderName = moreOptionValue;

            if (this.moreMap.has(moreOptionValue)) {
                this.moreMap.set(moreOptionValue, !this.moreMap.get(moreOptionValue));
            } else {
                this.moreMap.set(moreOptionValue, true);
            }
            this.moreOptions = this.moreMap.get(moreOptionValue);
        },

        sendTabEvent(tabName, index) {
            this.tabIndex = index;
            this.enableAddHeader = true;
            this.selectedTab = tabName;
            this.headerList = this.contactCustomizableLayout.layoutComponents
            && this.contactCustomizableLayout.layoutComponents[index]
            && this.contactCustomizableLayout.layoutComponents[index].components
            && this.contactCustomizableLayout.layoutComponents[index].components !== undefined
            && this.contactCustomizableLayout.layoutComponents[index].components.length > 0
                ? this.contactCustomizableLayout.layoutComponents[index].components : [];
        },

        getStandardFieldName() {
            const fieldsArray = this.contactCustomizableLayout.layoutComponents && this.contactCustomizableLayout.layoutComponents.map((heaCom) => heaCom.components
                    && heaCom.components.map((fieldComp) => fieldComp.components
                            && fieldComp.components.filter((allNames) => allNames.contentType && !allNames.contentType.includes('CUSTOM')).map((sysNames) => sysNames.name)));

            this.allFieldNames = fieldsArray !== undefined ? fieldsArray.flat().flat() : [];

            for (const fild in this.allFieldNames) {
                if ([...this.allFieldNames][fild]) {
                    const fieldInd = this.aliasSytemFields.findIndex((x) => x.name === this.allFieldNames[fild]);

                    if (fieldInd !== -1) {
                        this.aliasSytemFields.splice(fieldInd, 1);
                    }
                }
            }
            this.aliasSytemFields = this.aliasSytemFields.filter((plan) => plan.customField === false);
        },

        getAllCustomFieldNames() {
            const fieldsArray = this.contactCustomizableLayout.layoutComponents && this.contactCustomizableLayout.layoutComponents.map((heaCom) => heaCom.components
                    && heaCom.components.map((fieldComp) => fieldComp.components
                            && fieldComp.components.filter((allNames) => allNames.contentType && allNames.contentType.includes('CUSTOM')).map((sysNames) => sysNames.name)));
            const customFieldsnames = fieldsArray !== undefined ? fieldsArray.flat().flat() : [];

            for (const fild in customFieldsnames) {
                if ([...customFieldsnames][fild]) {
                    const fieldInd = this.aliasCustomFields.findIndex((x) => x.name === customFieldsnames[fild]);

                    if (fieldInd !== -1) {
                        this.aliasCustomFields.splice(fieldInd, 1);
                    }
                }
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.header-list {
    display: grid;
    grid-row-gap: 1rem;
    grid-column-gap: 1rem;
    grid-template-columns: repeat(1, 1fr);
}

.fields-icons-remove {
    float: right;
}

.fields-icons {
    display: inline-flex;
}

.dropdown-menu-item {
    white-space: pre-wrap;
}

.fields-more-remove-icons {
    width: 2rem;
    height: 2rem;
    padding: $spacing-100;
    border-radius: 0.25rem;
}

.field-names-text {
    margin-top: $spacing-100;
    color: $color-gray-darker;
    font-size: 0.869rem;
    font-weight: normal;
}

.clear-icon {
    --icon-color: #{$color-ink};
    cursor: pointer;
}

.new-custom-field-label {
    width: 100%;
}

.drag-target-field {
    margin: 0 $spacing-100 0px $spacing-200;
}

.drag-icon {
    display: inline-flex;
    --icon-color: $color-gray;
    cursor: grab;
    --icon-size: 1rem;
    margin: 0 $spacing-100 0 $spacing-050;
}

.card-header {
    justify-content: space-around;
    text-align: center;
    font-size: $font-size-md;
    text-justify: initial;
    margin-right: auto;
    margin-left: auto;
    font-weight: 300;
    padding-top: 8rem;
    padding-bottom: 3rem;
}

.add-field {
    margin-top: $spacing-200;
    margin-left: $spacing-200;
    color: $color-blue;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: inline-grid;
    grid-template-columns: auto auto;
    grid-gap: .5rem;
    cursor: pointer;
    display: -ms-inline-flexbox;
    display: inline-flex;
}

.add-tab-label {
    margin-left: $spacing-100;
}

.add-a-tab-label {
    margin-left: $spacing-100;
    margin-top: 0.4rem;
    float: right;
}

.names-incard {
    height: 3.5rem;
    padding: $spacing-100 $spacing-200 $spacing-100 $spacing-300;
    background-color: $color-white;
}

.moreOptions {
    display: flex;
    float: right;
}

.ds-card-header {
    padding: 0.5rem;
    display: grid;
    margin-top: 0.263rem;
    grid-gap: 0.5rem;
}

.ds-card-body {
    padding: 0.25rem;
}

.ds-card {
    margin-bottom: $spacing-200;
    max-width: 100%;
    cursor: pointer;
}

.tooltip {
    @include position(absolute 0 0 auto auto);
    --tooltip-width: 19rem;
    --icon-color: #{$color-blue};
    --icon-size: #{0.66rem};

    .label {
        margin: 0 $spacing-050;
    }
}

.from-template {
    color: $color-gray;
    margin-left: 0.55rem;
}

.search {
    --input-margin-bottom: 0;
    --input-padding-left: 0;
    --input-border: none;
    --input-focus-border: none;
    --select-field-focus-border: none;
    --quill-editor-border-radius: 0;
    --quill-editor-bottom-border-color: transparent;
    --multiselect-input-border: none;

    border-top: none;
    border-bottom: var(--input-focus-border, 1px solid #{$color-gray-600});
    border-radius: 0;
}

.search-border {
    border-bottom: var(--input-focus-border, 1px solid #{$color-gray-600});
}

.div-filed-type-info {
    padding: $spacing-100;
    border-radius: 0.571rem;
    background-color: $color-gray-100;
    display: flex;
}

.info-text {
    margin: 0 0.5rem 1rem;
}

.toast-action {
    color: $color-black;
}

.help {
    color: $color-blue;
    font-size: $font-size-xs;
    cursor: pointer;
}

h6.semibold {
    margin: 0 0 $spacing-200;
}

.field-options {
    --input-margin-bottom: #{$spacing-100};
    background: $color-gray-050;
    border-radius: $border-radius;
    border: 1px solid $color-gray-400;
    padding: $spacing-200;

    small {
        color: $color-gray-800;
    }
}

.field-settings {
    --checkbox-padding: 0;
    margin-top: $spacing-200;

    small {
        display: block;
        margin: 0 $spacing-400;
    }
}

.add-a-field-dropdown {
    --dropdown-height: #{px-to-rem(288px)};
    --dropdown-minwidth: #{px-to-rem(200px)};
    --dropdown-maxwidth: #{px-to-rem(275px)};
}

.chevron-header {
    margin-top: 0.66rem;
}

</style>
